import { Client } from '../../client';
import type { ISongPeaks } from '../../../entities';
import { SongPeaks } from '../../../entities';
import { ExternalResourcesRepository } from '../../repositories/externalResourcesRepository';
import { handleErrors } from '../../../helpers';
import { SongPeaksResponse } from '../../../responses/responseTypes';

export default class ExternalResourcesRepositoryImpl
  implements ExternalResourcesRepository
{
  client: Client;

  constructor(client: Client) {
    this.client = client;
  }

  getWaveform(path: string): Promise<ISongPeaks> {
    const { client } = this;
    return new Promise((resolve, reject) => {
      client
        .get<SongPeaksResponse>(path)
        .then((response) => {
          resolve(new SongPeaks(response.data));
        })
        .catch((err) => {
          const error = handleErrors(err);
          return reject(error);
        });
    });
  }
}
